import type { IconSvgObject } from './types';

const ParaglidingIcon: IconSvgObject = [
  ["path", { d: "M12 10.902L2.00402 15C2.00402 14.0305 1.92087 13.0354 2.51085 12.1986C4.55645 9.29747 9.32543 4.89922 12 3C14.6746 4.89922 19.4436 9.29747 21.4892 12.1986C22.0791 13.0354 21.996 14.0305 21.996 15L12 10.902Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 12L8.43874 16.6838C8.2229 17.3313 8.70487 18 9.38743 18H14.6126C15.2951 18 15.7771 17.3313 15.5613 16.6838L14 12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 18V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8.5 16.5L4.5 14M15.5 16.5L19.5 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ParaglidingIcon;
